import styled from "styled-components/native";

export const Container = styled.ScrollView``;
